/**
 * To enable or disable MFA the password needs to be verified
 * Validation based on accounts mfa_enabled status 
 * Will pass along valid totp_uri and validation_token if enabling
 */
import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import DialogInterface from '@/interfaces/dialog';
import template from '@/../templates/mfa/dialog-mfa-verify.hbs';
import MFAConfirmTOTP from '@/views/dialogs/confirm_mfa_totp';

var globalCh = Radio.channel('global');
var alertCh = Radio.channel('alerts');

var disable_message = 'Multi-Factor Authentication has been disabled for this account';
var regen_message = 'New recovery codes have been generated for your account';
var fail_message = `We're sorry, something has gone wrong, please try again`;

var view = Marionette.View.extend(DialogInterface).extend({
    id: 'enable-mfa-dialog',
    template: Handlebars.compile(template),
    ui: {
        current_password: '#current-password',
        load_spinner: '.loader',
        submit_btn: '.btn.btn-primary',
        form: 'form',
    },
    initialize: function (options) {
        this.destroyOnClose();
        this.focusFirstInput();
    },
    events: {
        'submit form': 'onSubmit',
        'keyup @ui.current_password': 'validate'
    },
    validate: function(e) {
        if (e.target.value.length > 0) {
            this.ui.submit_btn.attr('disabled', false);
        } else {
            this.ui.submit_btn.attr('disabled', true);
        }
    },
    templateContext: function() {
        return {
            title: this.getOption('title'),
            description: this.getOption('description'),
        };
    },
    onSubmit: function (event) {
        event.preventDefault();

        var options = {
            current_password: this.ui.current_password.val(),
        };
        if (this.getOption('regenerate_codes') && this.model.get('mfa_enabled')) {
            this.regenerate_recovery_keys(options);
        } else if (this.model.get('mfa_enabled')) {
            this.disable_mfa(options);
        } else {
            this.enable_mfa(options);
        }
    },
    disable_mfa: function (options) {
        var self = this;
        this.model.remove_mfa(options)
            .then(function(){
                globalCh.request('show_mfa', self.model);
                self.closeDialog();
                alertCh.request('showAlert', {
                    message: disable_message,
                    messageType: 'warning',
                    timeout: 5000
                });
            })
            .fail(function (err) {
                var message = err.responseJSON.errors[0].detail || fail_message;
                self.showAlert('error', message);
                return;
            });
    },
    enable_mfa: function(options) {
        var self = this;
        this.model.request_mfa_verification(options)
            .done(function (r) {
                // Move to the next dialog and pass totp_uri, token
                var view = new MFAConfirmTOTP({
                    model: self.model,
                    totp_uri: r.totp_uri,
                    verification_token: r.verification_token,
                    secret: r.secret,
                });
                globalCh.request('showDialog', view);
                return;

            })
            .fail(function (err) {
                var message = err.responseJSON.errors[0].detail || fail_message;
                self.showAlert('error', message);
                return;
            });
    },
    regenerate_recovery_keys: function(options) {
        var self = this;
        this.model.regenerate_recovery_keys(options)
            .done(function(r){
                globalCh.request('show_mfa', self.model);
                self.closeDialog();
                alertCh.request('showAlert', {
                    message: regen_message,
                    messageType: 'success',
                    timeout: 5000
                });
            })
            .fail(function(err){
                var message = err.responseJSON.errors[0].detail || fail_message;
                self.showAlert('error', message);
                return;
            });
    }
});

export default view;

